<template>
    <div class="solutionguide__result-table">
        <div class="solutionguide__result-label">{{$t('result.label.component')}}</div>
        <div class="solutionguide__result-label">{{$t('result.label.product')}}</div>
        <div class="solutionguide__result-label">{{$t('result.label.surface')}}</div>
        <div class="solutionguide__result-label">{{$t('result.label.decor')}}</div>
        <template v-for="row in rows">
            <div class="solutionguide__result-line"></div>
            <div class="solutionguide__result-mobilelabel">{{$t('result.label.component')}}</div>
            <div class="solutionguide__result-component">
                <div><strong>{{row.component.name}}</strong></div>
                <img :src="row.component.icon" alt="" :title="row.component.name"/>
            </div>
            <div class="solutionguide__result-mobilelabel">{{$t('result.label.product')}}</div>
            <div class="solutionguide__result-productcol">
                <div class="solutionguide__result-product">
                    <a v-if="row.product.detail_link" :href="row.product.detail_link" target="_blank">
                        <img :src="row.product.image_src" alt="" :title="row.product.title" class="solutionguide__result-product-img" />
                    </a>
                    <img v-else :src="row.product.image_src" alt="" :title="row.product.title" class="solutionguide__result-product-img" />
                    <component :is="row.product.detail_link ? 'a' : 'p'" :href="row.product.detail_link" target="_blank">
                        <span><strong>{{row.product.title}}</strong> {{row.product.titlesuffix}}</span><br />
                        <span v-if="row.product.category">{{row.product.category}}</span>
                    </component>
                </div>
            </div>
            <div class="solutionguide__result-mobilelabel">{{$t('result.label.surface')}}</div>
            <div class="solutionguide__result-properties">
                <ul>
                    <li v-for="property in getProperties(row.product.propertyIds)">
                        {{property.name}}
                    </li>
                </ul>
            </div>
            <div class="solutionguide__result-mobilelabel">{{$t('result.label.decor')}}</div>
            <div class="solutionguide__result-decor">
                <result-table-row-decor :component="row.component" :product="row.product" />
            </div>
        </template>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import StepWrapper from "./step-wrapper.vue";
import {SolutionGuide} from "../../../../../_types/solutionguide";
import ResultTableRowDecor from "./result-table-row-decor.vue";

export interface ResultTableRow {
    component: SolutionGuide.Component
    product: SolutionGuide.DekorativePlatte
}

export default Vue.extend({
    name: "result-table",
    components: {ResultTableRowDecor, StepWrapper},
    props: {
        rows: {
            type: Array as () => ResultTableRow[]
        }
    },
    methods: {
        getProperties(propertyIds: string[]) {
            return this.$store.getters.sortAndResolvePropertyIds(propertyIds)
        }
    }
})
</script>
